import React from 'react';
import { Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';

const DonorLinkRescueDataTable = ({ rescueData = [] }) => (
  <Table size="small">
    <TableHead>
      <TableRow>
        <TableCell>Item</TableCell>

        <TableCell>Quantity</TableCell>
      </TableRow>
    </TableHead>

    <TableBody>
      {rescueData.map((item) => (
        <TableRow key={item?.name}>
          <TableCell>{item?.name}</TableCell>

          <TableCell>{item?.quantity}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export default DonorLinkRescueDataTable;
